import { BehaviorSubject, Observable } from 'rxjs';

export interface StateURL {
  value: string;
}

export class onPageNavigateState {
  private static modeChangeState$: BehaviorSubject<StateURL> =
    new BehaviorSubject<StateURL>(null);

  static setModeChangeState(state: StateURL): void {
    onPageNavigateState.modeChangeState$.next(state);
  }

  static getModeChangeState(): Observable<StateURL> {
    return onPageNavigateState.modeChangeState$;
  }
}
